import React, { useCallback, useMemo, useState } from 'react';
import { InfoModalConfig, InfoModalContext } from './Context';

const InfoModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [current, setCurrent] = useState<InfoModalConfig | undefined>(undefined);

  const showInfoModal = useCallback((title: string, content: React.ReactElement | string) => {
    setCurrent({ title, content });
  }, []);

  const clearInfoModal = useCallback(() => {
    setCurrent(undefined);
  }, []);

  const value = useMemo(() => ({ current, showInfoModal, clearInfoModal }), [current, showInfoModal, clearInfoModal]);

  return <InfoModalContext.Provider value={value}>{children}</InfoModalContext.Provider>;
};

export default InfoModalProvider;
